import React from "react";
import "./faqinfo.css";

// Edit questions here. `open: true` makes a question start expanded.
const faqs = [
  {
    q: "Can I apply to more than one sub-team?",
    a: (
      <p>
        You may apply to as many sub-teams as you’d like! Applying to multiple
        sub-teams will not negatively affect your chances of being accepted
        into the team.
      </p>
    ),
    open: true,
  },
  {
    q: "What is the application process like?",
    a: (
      <>
        <div className="faq-steps">
          <div className="faq-step">
            <span className="faq-step-label">STEP 1</span>
            <span className="faq-step-name">Written application</span>
          </div>
          <div className="faq-step">
            <span className="faq-step-label">STEP 2</span>
            <span className="faq-step-name">Sub-team interview</span>
          </div>
          <div className="faq-step">
            <span className="faq-step-label">STEP 3</span>
            <span className="faq-step-name">Final decision</span>
          </div>
        </div>
        <p>
          Each sub-team has its own written application and interview. After
          submitting your application, you will be notified by email if you are
          selected to advance to the interview stage. You must sign up for an
          interview by the specified deadline.
        </p>
        <p>
          Once all interviews for the sub-team have been completed, you will
          receive an email informing you of the final decision. If you receive
          an offer to join the team, you must accept it by the specified
          deadline.
        </p>
      </>
    ),
    open: true,
  },
  {
    q: "When are your recruitment cycles?",
    a: (
      <p>
        We do 2 recruitment cycles each academic year: one at the beginning of
        the Fall semester and one at the beginning of the Winter semester.
      </p>
    ),
  },
  {
    q: "How can I keep up to date about application timelines, info sessions, etc.?",
    a: (
      <p>
        Follow us on Instagram{" "}
        <a
          href="https://www.instagram.com/macformulaelectric"
          target="_blank"
          rel="noopener noreferrer"
        >
          @macformulaelectric
        </a>
        ! We will post when we are actively hiring, info session times, a story
        for when interview offers have gone out, etc.
      </p>
    ),
  },
  {
    q: "Can I email my application to increase my chances of getting accepted?",
    a: (
      <p>
        No, all applications submitted by email will be ignored. You must
        submit your application through the respective sub-team form.
      </p>
    ),
  },
  {
    q: "My laptop says it’s still before 11:59 PM on the due date. Why can’t I submit?",
    a: (
      <p>
        The deadline has passed, as the Microsoft Forms submission end time is
        not based on the responder’s personal clock. We recommend completing
        the application early and re-syncing your laptop clock to avoid this
        issue in the future.
      </p>
    ),
  },
  {
    q: "Something went wrong (power failure, lost Wi-Fi, etc.) and I couldn’t submit on time. Can I apply by email?",
    a: (
      <p>
        Unfortunately, to keep the application process fair, we cannot
        consider any applications after the deadline. We strongly recommend
        submitting the application early to account for extenuating
        circumstances that may prevent your submission right before the
        deadline. We encourage you to apply during our next recruitment cycle.
      </p>
    ),
  },
  {
    q: "I missed the deadline. Can I still join the team?",
    a: (
      <p>
        Unfortunately, to keep the application process fair, we cannot
        consider any applicants after the deadline. We encourage you to apply
        during our next recruitment cycle.
      </p>
    ),
  },
  {
    q: "I wasn’t accepted. Can I drop in to watch and learn about your work?",
    a: (
      <p>
        Unfortunately, due to limited time, space, and resources, only team
        members are permitted in our Hatch Bay, and we do not offer drop-in
        sessions.
      </p>
    ),
  },
  {
    q: "Why wasn’t I selected for an interview or accepted onto the team?",
    a: (
      <>
        <p>
          MACFE receives applications from many bright and eligible McMaster
          students, and it’s a difficult decision for us to make. However, we
          have a limited number of students we can take each year, and we must
          select according to our goals for this build cycle.
        </p>
        <p>
          Not receiving an offer does not mean you lack the skills or potential
          to contribute to the team. We encourage you to apply again during a
          future recruitment cycle! If you would like feedback on your
          application or interview, feel free to reach out to the respective
          sub-team lead.
        </p>
      </>
    ),
  },
];

function PlusIcon() {
  return (
    <svg
      className="faq-icon"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export default function FAQ() {
  return (
    <section id="faq" className="faq-container">
      <div className="faq-inner">
        <div className="faq-side">
          <div className="faq-eyebrow">BEFORE YOU REACH OUT</div>
          <h2 className="faq-title">
            Recruitment
            <br />
            FAQ
          </h2>
          <div className="faq-accent" />
          <p className="faq-side-text">
            Timelines, info sessions and interview updates are posted on
            Instagram.
          </p>
          <a
            className="faq-ig-button"
            href="https://www.instagram.com/macformulaelectric"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              aria-hidden="true"
            >
              <rect x="3" y="3" width="18" height="18" rx="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
            </svg>
            @macformulaelectric
          </a>
        </div>

        <div className="faq-list">
          {faqs.map((item, i) => (
            <details className="faq-item" key={item.q} open={item.open}>
              <summary className="faq-summary">
                <span className="faq-num">{String(i + 1).padStart(2, "0")}</span>
                <span className="faq-question">{item.q}</span>
                <PlusIcon />
              </summary>
              <div className="faq-answer">{item.a}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}